import React from "react";
import { MdDone, MdEmail } from "react-icons/md";
import {
    FacebookShareButton,
    WhatsappIcon,
    FacebookIcon,
    TwitterShareButton,
    TwitterIcon,
    WhatsappShareButton,
    EmailIcon,
    EmailShareButton,
    FacebookMessengerShareButton,
    FacebookMessengerIcon,
    LinkedinShareButton,
    LinkedinIcon,
} from "react-share";
import { FaFacebookF, FaLinkedinIn, FaTwitter } from "react-icons/fa";
import { BsFacebook, BsTwitter, BsMessenger } from "react-icons/bs";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { HiMail } from "react-icons/hi";
import { IoLogoWhatsapp } from "react-icons/io";
import { ticktesCartItem } from "Actions/eventActions";
import moment from "moment";
import { useEffect } from "react";
import { createBrowserHistory } from "history";
import * as constants from "Constants";
import { useState } from "react";
import { IoArrowBack } from "react-icons/io5";
import { history } from "store";
import { routeName } from "Service/env";
import Navbar from "Components/UBMeEvents/Components_UBMeEvents/Navbar/Navbar";
function PaymentSuccess({
                            isLoggedIn,
                            currentEventDetails,
                            results,
                            cartItems,
                            ticktesCartItem,
                            shoppingCartDetails,
                            dispatch,
                        }) {
    // const ticketQty = cartItems?.reduce((a, c) => a + Number(c.Quantity), 0);
    // const [ locationKeys, setLocationKeys ] = useState([])
    // if(isLoggedIn) {

    //   window.onpopstate = function(event) {
    //     history.go(1);
    //   };
    // }


    useEffect(() => {
        localStorage.setItem("payment", "success");
    }, []);

    const [pdfReady, setPdfReady] = useState(false);
    let appToken = localStorage.getItem("app-token");


    const searchParams = new URLSearchParams(window.location.search);
    const isEmbed = searchParams.get("embed") === "true";

    const eventDetails = isEmbed
        ? {
            EventId: searchParams.get("eventId"),
            Title: searchParams.get("title"),
            StartDateTime: searchParams.get("start"),
            EndDateTime: searchParams.get("end"),
            Add1: searchParams.get("address"),
        }
        : currentEventDetails;

    const sessionId = isEmbed
        ? searchParams.get("sessionId")
        : shoppingCartDetails?.CartSession?.SessionId;

    const ticketQty = isEmbed
        ? Number(searchParams.get("ticketQty"))
        : cartItems?.reduce((a, c) => a + Number(c.Quantity), 0);

    const isRecurringTicket = isEmbed
        ? searchParams.get("isRecurring") === "true"
        : cartItems?.some((x) => x.RecurringTicket === "True" || x.RecurringTicket === "true");

    const finalIsLoggedIn = isEmbed
        ? false
        : isLoggedIn;

    const email = searchParams.get("email") ||
        JSON.parse(localStorage.getItem("additionalInfo"))?.Email ||
        "";

    const backToHome = () =>
        history.replace(`${routeName}/event/${eventDetails.EventId}`);

    useEffect(() => {
        if (finalIsLoggedIn || !sessionId) return;

        const pdfUrl = `${constants.URLs.eventImagesUrl}/EventTicketsPDF/${sessionId}.pdf`;

        let attempts = 0;
        const maxAttempts = 15; // ~30 seconds

        const checkPdf = async () => {
            try {
                const res = await fetch(pdfUrl, {
                    method: "HEAD",
                    cache: "no-store",
                });

                if (res.ok) {
                    setPdfReady(true);
                    return;
                }
            } catch (e) {}

            attempts++;
            if (attempts < maxAttempts) {
                setTimeout(checkPdf, 2000);
            }
        };

        checkPdf();
    }, [sessionId, finalIsLoggedIn]);

    // const isRecurringTicket = cartItems.some(
    //   (x) => x.RecurringTicket === "True" || x.RecurringTicket === "true"
    // );

    const convertTimeUtcToLocal = (time) => {
        const UtcToLocal = moment
            .utc(time)
            .local()
            .format("MM/DD/YYYY hh:mm:ss A");
        var Time = moment(UtcToLocal, "MM/DD/YYYY hh:mm:ss A");

        const convertedTime = Time.tz(currentEventDetails?.TimeZone);
        return moment(convertedTime).format("MM/DD/YYYY hh:mm:ss A");
    };

    return (
        <React.Fragment>
            {appToken === null && !isEmbed ? <Navbar /> : null}

            <div className="paymentSuccess">
                <div className="paymentUpper">
                    {/* <div>

          <IoArrowBack style={{cursor:'pointer', marginBottom:20}} onClick={backToHome} size={25} />

        </div> */}
                    <div className="paymentHeader">
                        <MdDone className="doneIcon" size={30} />
                        <h1>Thanks for your order!</h1>
                    </div>
                    <div className="orderDetail">
                        <h3>YOU'RE GOING TO</h3>
                        <h1 style={{ marginTop: 20, marginBottom: 50 }}>
                            {eventDetails?.Title}
                        </h1>

                        <div className="orderDesc">
                            <div className="orderDescLeft">
                                <h3>
                                    {ticketQty} {ticketQty > 1 ? "TICKETS" : "TICKET"} SENT TO
                                </h3>
                                <p style={{ marginTop: 10, color: "rgb(58 58 58)" }}>
                                    {email}
                                </p>
                                {/* <a href="">Send to another email address</a> */}
                            </div>
                            {isRecurringTicket ? (
                                ""
                            ) : (
                                <div className="orderDescRighjt">
                                    <h3>DATE</h3>
                                    <p style={{ marginTop: 10, color: "rgb(58 58 58)" }}>
                                        {eventDetails?.StartDateTime &&
                                        eventDetails?.EndDateTime ? (
                                            <>
                                                {isEmbed
                                                    ? `${moment(convertTimeUtcToLocal(eventDetails?.StartDateTime, eventDetails?.TimeZone)).format("llll")} - ${moment(convertTimeUtcToLocal(eventDetails?.EndDateTime, eventDetails?.TimeZone)).format("llll")}`
                                                    : `${moment(eventDetails?.StartDateTime).format("llll")} - ${moment(eventDetails?.EndDateTime).format("llll")}`
                                                }
                                                {/*{moment(eventDetails.StartDateTime).format("llll")} -{" "}*/}
                                                {/*{moment(eventDetails.EndDateTime).format("llll")}*/}
                                            </>
                                        ) : null}
                                    </p>

                                </div>
                            )}
                        </div>
                        <div className="orderLoaction">
                            <h3>LOCATION</h3>
                            <p style={{ marginTop: 10, color: "rgb(58 58 58)" }}>
                                {" "}
                                {eventDetails?.Add1}
                            </p>
                        </div>
                    </div>
                </div>
                <div className="orderDetailFooter">
                    <a
                        id="view-tickets"
                        href={
                            finalIsLoggedIn
                                ? `${routeName}/tickets`
                                : pdfReady
                                    ? `${constants.URLs.eventImagesUrl}/EventTicketsPDF/${sessionId}.pdf`
                                    : "#"
                        }
                        target={finalIsLoggedIn ? "_self" : "_blank"}
                        rel={finalIsLoggedIn ? undefined : "noopener noreferrer"}
                        className={`leave ${!finalIsLoggedIn && !pdfReady ? "disabled" : ""}`}
                        onClick={(e) => {
                            if (!finalIsLoggedIn && !pdfReady) {
                                e.preventDefault();
                            }
                        }}
                    >
                        {finalIsLoggedIn ? "View Tickets" : (pdfReady ? "View Tickets" : "Generating tickets…")}
                    </a>


                    <a
                        id="Add-To-Wallet"
                        href={`${routeName}/wallet/${sessionId}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="applewallet_button"
                    >
                        Add To Wallet
                    </a>
                    {/*<div className="orderSocial">*/}
                    {/*  <FacebookShareButton*/}
                    {/*    bgstyle="red"*/}
                    {/*    url={`${constants.URLs.baseUrl}/event/${currentEventDetails.EventId}`}*/}
                    {/*    // quote={"CampersTribe - World is yours to explore"}*/}
                    {/*    hashtag="#UBMeEvents"*/}
                    {/*    // className={styles.social_share_button}*/}
                    {/*  >*/}
                    {/*    <FaFacebookF className="orderSocioIcon" />*/}
                    {/*  </FacebookShareButton>*/}
                    {/*  <TwitterShareButton*/}
                    {/*    url={`${constants.URLs.baseUrl}/event/${currentEventDetails.EventId}`}*/}
                    {/*    // title={"CampersTribe - World is yours to explore"}*/}
                    {/*    hashtag="#UBMeEvents"*/}
                    {/*    // className={styles.social_share_button}*/}
                    {/*  >*/}
                    {/*    <BsTwitter className="orderSocioIcon" />*/}
                    {/*  </TwitterShareButton>*/}
                    {/*  <WhatsappShareButton*/}
                    {/*    url={`${constants.URLs.baseUrl}/event/${currentEventDetails.EventId}`}*/}
                    {/*    // title={"CampersTribe - World is yours to explore"}*/}
                    {/*    hashtag="#UBMeEvents"*/}
                    {/*    // className={styles.social_share_button}*/}
                    {/*  >*/}
                    {/*    <div*/}
                    {/*    //  className={styles.social_share_icon_bg}*/}
                    {/*    >*/}
                    {/*      <IoLogoWhatsapp className="orderSocioIcon" />*/}
                    {/*    </div>*/}
                    {/*  </WhatsappShareButton>*/}
                    {/*  <EmailShareButton*/}
                    {/*    url={`${constants.URLs.baseUrl}/event/${currentEventDetails.EventId}`}*/}
                    {/*    // title={"CampersTribe - World is yours to explore"}*/}
                    {/*    hashtag="#UBMeEvents"*/}
                    {/*    //  className={styles.social_share_button}*/}
                    {/*  >*/}
                    {/*    <div*/}
                    {/*    // className={styles.social_share_icon_bg}*/}
                    {/*    >*/}
                    {/*      <HiMail className="orderSocioIcon" />*/}
                    {/*    </div>*/}
                    {/*  </EmailShareButton>*/}
                    {/*  /!* <MdEmail className="orderSocioIcon" /> *!/*/}
                    {/*</div>*/}
                </div>
            </div>
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        results: state.loginResponse.results,
        isLoggedIn: state.loginResponse.isLoggedIn,
        currentEventDetails: state.eventReducer.currentEventDetails,
        cartItems: state.eventReducer.cartData,
        shoppingCartDetails: state.eventReducer.createshoppingCartDetails,
    };
};
const matchDispatchToProps = (dispatch) => {
    return {
        // AddToFavorite: () => dispatch(AddToFavorite),
        // SetCardData: () => dispatch(SetCardData),
        // LoginPopup: () => dispatch(LoginPopup),
        // currentEventTicketDetails,
        // ticktesCartItem,
        // GetDiscountDetails,
        // GetDiscountData,
        // GetEventMasterById,
        ticktesCartItem,
        dispatch,
    };
};

export default connect(mapStateToProps, matchDispatchToProps)(PaymentSuccess);
